import React from 'react';
import { pawtimoContent } from '../rich-content/pawtimo-complete-content';
import { AutomaticPageBuilder } from '../page-sections/automatic-page-builder';

const PawtimoDetailPage = () => {
  return <AutomaticPageBuilder content={pawtimoContent} />;
};

export default PawtimoDetailPage;
